<template>
  <CCol col="12">
    <CCard class="scroll-bar w-100 mx-auto">
      <div v-if="!widgetData" class="position-relative" style="height:300px;">
        <Loading showLoading />
      </div>
      <CCol v-else col="12" class="mx-auto" style="min-width: 700px;">
        <CChartLine
          :datasets="[
            {
              data: widgetData.current.data,
              backgroundColor: '#b266f8',
              fill: false,
              borderColor: 'blueviolet',
              borderWidth: 1,
            },
            {
              data: widgetData.previous.data,
              backgroundColor: '#fa8d8d',
              fill: false,
              borderColor: '#e55353',
              borderWidth: 1,
              borderDash: [10, 5],
            },
          ]"
          :labels="widgetData.current.labels"
          :options="defaultOptions"
          style="height: 300px;"
        />
      </CCol>
      <CCol col="12" sm="12" class="text-center mb-3 mb-sm-4" style="min-width: 700px;">
        <CButtonGroup class="">
          <CButton class="font-xs circle-btn" :class="selectedWidgetModel === 16 ? 'activeModel' : ''" @click="change(16)">
            <FaIcon class="font-xs" icon="circle" />
            <span class="d-block">بازاریابان فعال</span>
          </CButton>
          <CButton class="font-xs circle-btn" :class="selectedWidgetModel === 15 ? 'activeModel' : ''" @click="change(15)">
            <FaIcon class="font-xs" icon="circle" />
            <span class="d-block">{{ programType.is_sale && programType.is_lead ? 'تعداد کانورژن‌ها' : ( programType.is_lead ? 'تعداد لیدها' : 'تعداد فروش‌ها' ) }}</span>
          </CButton>
          <CButton v-if="programType.is_sale" class="font-xs circle-btn" :class="selectedWidgetModel === 14 ? 'activeModel' : ''" @click="change(14)">
            <FaIcon class="font-xs" icon="circle" />
            <span class="d-block">مجموع فروش</span>
          </CButton>
          <CButton class="font-xs circle-btn" :class="selectedWidgetModel === 13 ? 'activeModel' : ''" @click="change(13)">
            <FaIcon class="font-xs" icon="circle" />
            <span class="d-block">کلیک‌ها</span>
          </CButton>
        </CButtonGroup>
      </CCol>
    </CCard>
  </CCol>
</template>

<script>
import { widgetService } from '@/services/api';

export default {
  name: 'ReportsBarChartForStore',

  data() {
    return {
      selectedWidgetModel: 13,
      widgetData: undefined
    }
  },

  computed: {
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        title: {
          fontFamily: "Vazir FD",
        },
        legend: {
          display: false,
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 30,
            bottom: 10
          }
        },
        tooltips: {
          fontFamily: "Vazir FD",
          callbacks: {
            label(tooltipItem) {
              return tooltipItem.yLabel;
            },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,

              },
            },
          ],
        },
        plugins: {
          tooltip: {
            bodyFont: {
              font: {
                family: "Vazir FD",
              },
            },
          },
        },
      };
    },
    programType() {
      return Object.keys(this.$currentUser().store).length > 0 ? this.$currentUser().store.program_type : {
        is_sale: true,
        is_lead: true,
      }
    }
  },

  methods: {
    change(model) {
      this.selectedWidgetModel = model
      this.fetchWidgetData()
    },
    fetchWidgetData() {
      this.widgetData = undefined
      let config = {
        duration: 30
      }

      if (this.selectedWidgetModel === 14 && this.programType.is_sale) {
        config.program_type = 'sale'
      }

      if (this.selectedWidgetModel === 15) {
        if (this.programType.is_sale && this.programType.is_lead) {
          //
        } else if (this.programType.is_lead) {
          config.program_type = 'lead'
        } else {
          config.program_type = 'sale'
        }
      }

      widgetService.fetch({
        needles: {
          [this.selectedWidgetModel]: { model: this.selectedWidgetModel, config: config }
        }
      }).then(res => {
        const result = res.data.data[this.selectedWidgetModel].result

        let current = {
          data: [],
          labels: [],
        }
        let previous = {
          data: [],
          labels: [],
        }

        result.current.forEach((it, index) => {
          current.data.push(it.value);
          current.labels.push(index + 1);
        });
        result.previous.forEach((it, index) => {
          previous.data.push(it.value);
          previous.labels.push(index + 1);
        });

        this.widgetData = {
          current: current,
          previous: previous,
        }
      })
    }
  },

  created() {
    Chart.defaults.global.defaultFontSize = 11;
    Chart.defaults.global.defaultFontFamily = 'Vazir FD';

    this.fetchWidgetData()
  }
}
</script>


<style scoped lang="scss">
::v-deep {
  .btn.circle-btn:focus {
    box-shadow: unset!important;
  }

  .activeModel {
    svg {
      scale: 1.2;
      transition: all 0.3s;
    }
    transition: all 0.2s;
    color: var(--primary);
  }

  .scroll-bar {
    display: flex;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-right: -20px;
  }
  @media only screen and (min-width: 992px) {
    .scroll-bar {
      justify-content: center;
    }
  }
  @media only screen and (max-width: 991px) {
    .scroll-bar {
      flex-wrap: nowrap;
      overflow-x: scroll;
    }
    .scroll-bar::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>